module.exports = angular.module('cartographer.common.http', [])

_ = require 'underscore'

module.exports.config $DI ($httpProvider) ->
  # Disable caching of HTTP responses in IE8 (and possibly later):
  $httpProvider.defaults.headers.common['If-Modified-Since'] = '0'
  return

module.exports.factory 'crtHttp', $DI (
  crtLog
  $q
  $http
  $window
  crtModal
  crtConfig
  crtSerialize
  crtDatetime
  crtHttpModals
) ->
  # The value to send to the server in the Authorization header:
  #
  # or(string null)
  _accessToken = null

  # -> string
  accessToken = ->
    _accessToken

  # or(string null) -> void
  setAccessToken = (token) ->
    # crtLog.debug('crtHttp.setAccessToken', token)
    _accessToken = token
    return

  reservedSubdomains = [
    "api"
    "app"
    "attach"
    "attachment"
    "help"
    "login"
    "widget"
    "upload"
    "static"
  ]

  # string boolean -> object
  requestHeaders = (contentType = undefined) ->
    ans = {}

    if contentType?
      ans["Content-Type"] = contentType

    if _accessToken
      ans["Authorization"] = "Bearer #{_accessToken}"

    ans["Cartographer-Client"] = "#{crtConfig.app.name}/#{crtConfig.app.version}"

    # crtLog.debug('crtHttp.requestHeaders', ans)
    ans

  # usefulObject -> encodedObject
  encodeRequestData = (data) ->
    ans = crtSerialize.encode(data ? null)
    # crtLog.debug('crtHttp.encodeRequestData', data, ans)
    ans

  # encodedObject -> usefulObject
  decodeResponseData = (data) ->
    ans = crtSerialize.decode(data ? null)
    # crtLog.debug('crtHttp.decodeResponseData', data, ans)
    ans

  # object -> string
  stringifyRequestData = (data) ->
    if data?
      if crtConfig.http.prettyPrint
        JSON.stringify(data, null, 2)
      else
        JSON.stringify(data)
    else
      null

  # string -> object
  parseResponseData = (str) ->
    try
      ans = if str then JSON.parse(str) else null
      # crtLog.debug('crtHttp.parseResponseData', str, ans)
      ans
    catch exn
      return {
        type      : "error"
        timestamp : crtDatetime.formatIso8601(crtDatetime.create())
        exception : "Could not parse the response from the server"
        response  : str
      }

  createUrl = (base, params, hash = undefined) ->
    query = []
    for key, value of params
      if _.isArray(value)
        for item in value
          query.push("#{encodeURIComponent(key)}=#{encodeURIComponent(item)}")
      else if value?
        query.push("#{encodeURIComponent(key)}=#{encodeURIComponent(value)}")
    if query.length == 0
      if !hash?
        base
      else
        "#{base}##{hash}"
    else
      if !hash?
        "#{base}?#{query.join("&")}"
      else
        "#{base}?#{query.join("&")}##{hash}"

  unpackResponse = (response) ->
    response.data

  # Response handlers that report errors in a modal dialog:
  defaultHandlers = {
    success: (response) ->
      response
    error: (response) ->
      switch response.status
        when 0
          crtHttpModals.showNetworkProblemModal(response)['finally'](-> $window.location.reload())
          $q.reject(response)
        when 400
          $q.reject(response)
        when 401
          switch response.data?.error
            when "ExpiredAuthorization"
              crtHttpModals.showExpiredAuthorizationModal(response)
              $q.reject(response)
            else
              crtHttpModals.showInvalidAuthorizationModal(response)
              $q.reject(response)
        when 403
          crtHttpModals.showForbiddenModal(response)
          $q.reject(response)
        when 413
          crtHttpModals.showDataTooLargeModal(response)
          $q.reject(response)
        when 500
          crtHttpModals.showInternalErrorModal(response)
          $q.reject(response)
        when 502
          crtHttpModals.showServersOfflineModal(response)['finally'](-> $window.location.reload())
          $q.reject(response)
        else
          $q.reject(response)
    notify: (response) ->
      return
  }

  # Response handlers that pass errors through:
  identityHandlers = {
    success: (response) -> response
    error:   (response) -> $q.reject(response)
    notify:  (response) -> return
  }

  # Response handlers that ignore errors (converting errors to `null`):
  ignoreHandlers = {
    success: (response) -> response
    error:   (response) -> null
    notify:  (response) -> return
  }

  request = (method, url, data = undefined, handlers = undefined) ->
    crtLog.info("crtHttp.request >>", "#{method} #{url}", data, handlers)
    handlers = if handlers then _.defaults(handlers, defaultHandlers) else defaultHandlers
    $http
      method            : method
      url               : url
      data              : data
      headers           : requestHeaders(if data? then "application/json" else null)
      transformRequest  : [ encodeRequestData, stringifyRequestData ]
      transformResponse : [ parseResponseData, decodeResponseData ]
    .then(
      (response) ->
        response = unpackResponse(response)
        crtLog.info("crtHttp.request <<", "#{method} #{url}", response)
        response
      (response) ->
        crtLog.warn("crtHttp.request !!", "#{method} #{url}", response)
        $q.reject(response)
    )
    .then(
      handlers.success,
      handlers.error,
      handlers.notify
    )

  get = (url, params = {}, handlers = {}) ->
    request('GET', createUrl(url, params), undefined, handlers)

  post = (url, data, handlers = {}) ->
    request('POST', url, data, handlers)

  put = (url, data, handlers = {}) ->
    request('PUT', url, data, handlers)

  del = (url, data, handlers = {}) ->
    request('DELETE', url, data, handlers)

  return {
    accessToken
    setAccessToken
    requestHeaders
    defaultHandlers
    identityHandlers
    ignoreHandlers
    request
    url: createUrl
    get
    post
    put
    delete: del
  }

module.exports.factory 'crtHttpModals', $DI ($window, crtModal, crtConfig) ->
  escapedResponseData = (response) ->
    angular.element('<div>').text(JSON.stringify(response.data, null, 2)).html()

  supportLink = (text) ->
    """<a href="#{crtConfig.company.supportContactUrl}" target="_blank">#{text}</a>"""

  showNetworkProblemModal = (response) ->
    crtModal.alert {
      title       : "Network Problem"
      content     : """
                    <p>Your web browser is unable to contact the Cartographer servers.
                    This is probably due to a problem with your connection to the Internet.</p>
                    <p>Please try again in a few minutes. If the problem persists,
                    please #{supportLink("contact support")} and quote this error message.</p>
                    """
      buttonLabel : "Reload"
    }

  showBadRequestModal = (response) ->
    crtModal.alert {
      title       : "Bad Request"
      content     : """
                    <p>Your web browser sent unexpected data to the Cartographer servers. Details follow:</p>
                    <pre>#{escapedResponseData(response)}</pre>
                    <p>Please #{supportLink("contact support")} and quote this error message.</p>
                    """
    }

  showExpiredAuthorizationModal = (response) ->
    crtModal.alert
      title       : "Session expired"
      content     : """
                    <p>Sorry! Your session with our servers has timed out.</p>
                    <p>Please log in again to continue.</p>
                    """
      buttonLabel : "Log in again"
    .then ->
      $window.location.reload()

  showInvalidAuthorizationModal = (response) ->
    crtModal.alert {
      title       : "Unauthorized"
      content     : """
                    <p>Your web browser did not identify you to the Cartographer servers. Details follow:</p>
                    <pre>#{escapedResponseData(response)}</pre>
                    <p>Please #{supportLink("contact support")} and quote this error message.</p>
                    """
    }

  showForbiddenModal = (response) ->
    crtModal.alert {
      title       : "Forbidden"
      content     : """
                    <p>You do not have permission to do that. Details follow:</p>
                    <pre>#{escapedResponseData(response)}</pre>
                    <p>Please #{supportLink("contact support")} and quote this error message.</p>
                    """
    }

  showDataTooLargeModal = (response) ->
    crtModal.alert {
      title       : "Data Too Large"
      content     : """
                    <p>The data you are transmitting to the Cartographer servers is too large.
                    Cartographer supports a maximum request size of 5 megabytes.</p>
                    <pre>#{escapedResponseData(response)}</pre>
                    <p>Please #{supportLink("contact support")} and quote this error message.</p>
                    """
    }

  showInternalErrorModal = (response) ->
    crtModal.alert {
      title       : "Internal Error"
      content     : """
                    <p>The Cartographer servers reported an internal error. Details follow:</p>
                    <pre>#{escapedResponseData(response)}</pre>
                    <p>Please try again in a few minutes. If the problem persists,
                    #{supportLink("contact support")} and quote this error message.</p>
                    """
    }

  showServersOfflineModal = (response) ->
    crtModal.alert {
      title       : "Servers Offline"
      content     : """
                    <p>The Cartographer servers are currently down for maintenance but should be back online very soon.</p>
                    <p>Please try again in a few minutes. If the problem persists,
                    #{supportLink("contact support")} and quote this error message.</p>
                    """
    }

  return {
    showNetworkProblemModal
    showBadRequestModal
    showExpiredAuthorizationModal
    showInvalidAuthorizationModal
    showForbiddenModal
    showDataTooLargeModal
    showInternalErrorModal
    showServersOfflineModal
  }
